import { Box, BoxProps } from '@mui/material';
import React from 'react';
import { makeStyles } from 'tss-react/mui';
import Typography from '@ui/Typography';

interface NoResultsFoundProps extends BoxProps {
  icon: React.ReactNode;
  subtitle: string;
}

const useStyles = makeStyles()(theme => ({
  errorCard: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'flex-start',
    textAlign: 'center',
    padding: theme.spacing(5),
    gap: theme.spacing(1.5),
  },
}));

const NoResultsFoundV2 = (props: NoResultsFoundProps) => {
  const { subtitle, icon } = props;
  const { classes } = useStyles();

  return (
    <Box className={classes.errorCard}>
      {icon}
      <Typography variant="pSm">{subtitle}</Typography>
    </Box>
  );
};

export default NoResultsFoundV2;
